import React, { useEffect, useRef } from "react";
import Typed from "typed.js";

export default function TypedText({ titles }) {
  const el = useRef(null);
  const typedInstance = useRef(null);

  useEffect(() => {
    if (!titles || titles.length === 0) return;

    typedInstance.current = new Typed(el.current, {
      strings: titles,
      typeSpeed: 50,
      backSpeed: 30,
      backDelay: 1500,
      loop: true,
      showCursor: false // hides cursor
    });

    return () => {
      typedInstance.current && typedInstance.current.destroy();
    };
  }, [titles]);

  return (
    <span
      style={{ whiteSpace: "pre" }}
      ref={el}
      className="mt-4 text-xl md:text-2xl text-white"
    />
  );
}
